export default __webpack_public_path__ + "static/media/pt-packages.415d5d8e.svg";